import { useState } from "react";
import papi, { perr, dfr } from "@/lib/portalApi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { SignaturePad } from "@/components/SignaturePad";
import { Check, X, PenLine } from "lucide-react";
import { toast } from "sonner";

const DECIDABLE = ["Envoyé", "Vu", "Négociation"];

export default function QuoteDecision({ q, clientName, onDone }) {
  const [mode, setMode] = useState("");
  const [nom, setNom] = useState(clientName || "");
  const [sig, setSig] = useState("");
  const [motif, setMotif] = useState("");
  const [busy, setBusy] = useState(false);
  if (q.statut === "Accepté" && q.client_signed_name) return <span className="text-xs text-emerald-700 inline-flex items-center gap-1" data-testid={`portal-quote-signed-${q.id}`}><PenLine className="h-3.5 w-3.5" />Signé par {q.client_signed_name} le {dfr(q.client_signed_at)}</span>;
  if (q.statut === "Refusé" && q.client_refusal_motif) return <span className="text-xs text-slate-500">Refusé : {q.client_refusal_motif}</span>;
  if (!DECIDABLE.includes(q.statut)) return null;
  const submit = async () => {
    setBusy(true);
    try {
      if (mode === "accept") await papi.post(`/quotes/${q.id}/accept`, { nom, signature: sig });
      else await papi.post(`/quotes/${q.id}/refuse`, { motif });
      toast.success(mode === "accept" ? "Merci ! Votre accord a bien été enregistré." : "Votre refus a été transmis à OMNIBAT.");
      setMode(""); onDone();
    } catch (e) { toast.error(perr(e)); } finally { setBusy(false); }
  };
  return <>
    <div className="flex gap-2 w-full sm:w-auto">
      <Button size="sm" onClick={() => setMode("accept")} className="bg-[#076633] hover:bg-[#05522a] text-white flex-1" data-testid={`portal-quote-accept-${q.id}`}><Check className="h-4 w-4 mr-1" />Accepter</Button>
      <Button size="sm" variant="outline" onClick={() => setMode("refuse")} className="text-rose-600 border-rose-200 flex-1" data-testid={`portal-quote-refuse-${q.id}`}><X className="h-4 w-4 mr-1" />Refuser</Button>
    </div>
    <Dialog open={!!mode} onOpenChange={(o) => !o && setMode("")}>
      <DialogContent className="max-w-md" data-testid="portal-quote-dialog">
        <DialogHeader><DialogTitle>{mode === "accept" ? `Accepter le devis ${q.numero}` : `Refuser le devis ${q.numero}`}</DialogTitle></DialogHeader>
        {mode === "accept" ? <div className="space-y-3">
          <p className="text-sm text-slate-600">En signant ci-dessous, vous donnez votre <b>bon pour accord</b> sur ce devis d'un montant de <b>{Math.round(q.total_ttc || 0).toLocaleString("fr-FR")} FCFA TTC</b>.</p>
          <Input value={nom} onChange={(e) => setNom(e.target.value)} placeholder="Nom et prénom du signataire" data-testid="portal-quote-nom" />
          <div data-testid="portal-quote-sig"><SignaturePad value={sig} onChange={setSig} height={150} /></div>
        </div> : <Textarea rows={3} value={motif} onChange={(e) => setMotif(e.target.value)} placeholder="Motif du refus (prix, délai, prestations…)" data-testid="portal-quote-motif" />}
        <DialogFooter><Button disabled={busy || (mode === "accept" ? !sig || nom.trim().length < 2 : motif.trim().length < 3)} onClick={submit}
          className={mode === "accept" ? "bg-[#076633] text-white" : "bg-rose-600 text-white"} data-testid="portal-quote-confirm">{mode === "accept" ? "Signer et accepter" : "Confirmer le refus"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>;
}
